var _path, _path2, _path3, _g, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponOther = function SvgCouponOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF3F4",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFD3",
    d: "M28.788 19.088c.45.45.887.918 1.357 1.348.306.28.31.465 0 .76-1.995 1.9-4.265 3.375-6.855 4.306-6.614 2.377-12.902 1.665-18.81-2.133-.98-.63-1.83-1.465-2.744-2.198-.287-.233-.297-.418-.02-.685.963-.938 1.908-1.893 2.85-2.85.25-.25.423-.283.703-.018 2.026 1.9 4.381 3.215 7.096 3.806 5.211 1.135 9.874-.023 13.932-3.506.706-.605.695-.615 1.348.033l1.14 1.14z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "couponOther_svg__a",
    width: 25,
    height: 21,
    x: 4,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M15.913 26.84c-5.945-.087-10.23-2.622-11.453-3.584l.35-16.962h23.344l-.437 16.787c-3.148 2.798-9.527 3.793-11.804 3.76"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#couponOther_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#961A0F",
    d: "m16.023 13.2-9.642 1.717v12.535h19.147V14.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E3E6",
    d: "M18.433 10.275q-.017.04-.03.08a2.01 2.01 0 1 0 3.813 1.275q.013-.04.024-.083l3.32 1.11-4.879 14.594-10.448-3.492L15.11 9.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.863 10.105q.017.035.035.071a1.81 1.81 0 0 0 3.167-1.755q-.02-.034-.042-.067l2.756-1.527 6.712 12.114-8.672 4.806-6.713-12.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "m13.036 10.243 3.367 5.319-.665.42-3.367-5.318zM11.487 11.225l1.684 2.66-.665.42-1.684-2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C82314",
    d: "m6.555 26.665 18.973-11.748v12.535H6.38v-.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5647",
    d: "M25.353 26.665 6.381 14.917v12.535h19.147v-.262z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C82314",
    d: "m1.84 11.364.095.296c.1.313.345.559.659.659l.296.094-.296.094c-.314.1-.56.346-.66.66l-.094.295-.094-.296a1.01 1.01 0 0 0-.659-.659l-.296-.094.296-.095c.314-.1.56-.345.659-.658zM30.168 9.091l.126.395c.133.418.46.745.878.878l.395.126-.395.126c-.418.133-.745.46-.878.879l-.126.394-.126-.394a1.35 1.35 0 0 0-.878-.879l-.395-.126.395-.126c.417-.133.745-.46.878-.878zM5.339 6.294l.157.494c.167.522.576.931 1.098 1.098l.494.157-.494.157a1.7 1.7 0 0 0-1.098 1.098l-.157.494-.157-.494A1.7 1.7 0 0 0 4.084 8.2l-.494-.157.494-.157a1.7 1.7 0 0 0 1.098-1.098z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.426,
    cy: 10.664,
    r: 4.14,
    fill: "#C82314",
    transform: "rotate(-15 21.426 10.664)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.772 12.739 2.397-4.17.953.002-2.397 4.169zm.172-2.209q-.261 0-.486-.112a1 1 0 0 1-.352-.31.78.78 0 0 1-.127-.429v-.251a.77.77 0 0 1 .286-.604q.151-.123.328-.187.176-.064.353-.064a1.07 1.07 0 0 1 .692.252.9.9 0 0 1 .212.278.76.76 0 0 1 .073.327v.251q0 .166-.074.326a.8.8 0 0 1-.207.273l-.006.005a1.04 1.04 0 0 1-.692.245m.001-1.23a.15.15 0 0 0-.103.038.12.12 0 0 0-.037.09v.252q0 .048.042.086t.098.037q.072 0 .09-.021l.013-.01q.055-.049.055-.092V9.43a.11.11 0 0 0-.049-.091.16.16 0 0 0-.109-.038m3.01 3.447q-.201 0-.383-.065a.9.9 0 0 1-.31-.187.795.795 0 0 1-.279-.605v-.245q0-.171.074-.327a.976.976 0 0 1 .9-.529q.375.001.685.248l.006.005a.9.9 0 0 1 .206.278.76.76 0 0 1 .073.326v.246a.834.834 0 0 1-.286.604.98.98 0 0 1-.687.251m0-1.23a.18.18 0 0 0-.109.037.12.12 0 0 0-.043.091v.246q0 .054.049.097v.005h.006q.03.027.097.027t.097-.027l.006-.005a.12.12 0 0 0 .043-.096v-.246a.13.13 0 0 0-.042-.097h-.007a.14.14 0 0 0-.097-.032"
  })));
};
export default SvgCouponOther;